export const en_XA = {
  // Header/Sidebar
  user: "[!!! Ûƨèř ℓ !!!]",
  users: "[!!! Ûƨèřƨ ℓ !!!]",
  installations: "[!!! ïñƨƭáℓℓáƭïôñƨ ℓôř !!!]",
  settings: "[!!! ƨèƭƭïñϱƨ ℓ !!!]",
  certificate: "[!!! çèřƭïƒïçáƭè ℓô !!!]",
  main_settings: "[!!! Máïñ §èƭƭïñϱƨ ℓôř !!!]",
  terminology: "[!!! Tèř₥ïñôℓôϱ¥ ℓô !!!]",
  equipment: "[!!! É9úïƥ₥èñƭ ℓô !!!]",
  security: "[!!! §èçúřïƭ¥ ℓ !!!]",
  tenants: "[!!! Tèñáñƭƨ ℓ !!!]",
  collapse: "[!!! Çôℓℓáƥƨè ℓ !!!]",
  branding: "[!!! ßřáñδïñϱ ℓ !!!]",
  sign_out: "[!!! §ïϱñ Óúƭ ℓ !!!]",
  hello: "[!!! Hèℓℓô! ℓ !!!]",

  // Misc
  save: "[!!! §áƲè  !!!]",
  cancel: "[!!! Çáñçèℓ ℓ !!!]",

  // Installation Table
  status: "[!!! §ƭáƭúƨ ℓ !!!]",
  clear: "[!!! Çℓèář ℓ !!!]",
  date: "[!!! Ðáƭè  !!!]",
  technician: "[!!! Tèçλñïçïáñ ℓô !!!]",
  customer_phone: "[!!! Çúƨƭô₥èř Þλôñè ℓôř !!!]",
  address: "[!!! Âδδřèƨƨ ℓ !!!]",
  unit: "[!!! Ûñïƭ ℓ !!!]",
  city: "[!!! Çïƭ¥  !!!]",
  state_prov: "[!!! §ƭáƭè/ÞřôƲ ℓô !!!]",
  rooms_tested: "[!!! Rôô₥ƨ Tèƨƭèδ ℓôř !!!]",
  tested: "[!!! Tèƨƭèδ ℓ !!!]",
  plan: "[!!! Þℓáñ  !!!]",
  rows_per_page: "[!!! Rôωƨ ƥèř ƥáϱè: ℓôř !!!]",
  notes: "[!!! Nôƭèƨ ℓ !!!]",

  // Certificate Branding Tab
  current_image: "[!!! Çúřřèñƭ Ì₥áϱè: ℓôř !!!]",
  using_default_logo: "[!!! Ûƨïñϱ Ðèƒáúℓƭ £ôϱô ℓôřè !!!]",
  new_image: "[!!! Nèω Ì₥áϱè ℓô !!!]",
  branding_loading_error:
    "[!!! ßřáñδïñϱ ℓôáδïñϱ èřřôř. Þℓèáƨè ƭř¥ áϱáïñ ℓáƭèř. ℓôřè₥ ïƥƨú₥ δ !!!]",
  upload_new_image: "[!!! Ûƥℓôáδ Nèω Ì₥áϱè ℓôřè !!!]",
  clear_custom_image: "[!!! Çℓèář Çúƨƭô₥ Ì₥áϱè ℓôřè !!!]",
  clear_custom_color: "[!!! Çℓèář Çúƨƭô₥ Çôℓôř ℓôřè !!!]",
  brand_color: "[!!! ßřáñδ Çôℓôř ℓô !!!]",
  header_message: "[!!! Hèáδèř Mèƨƨáϱè ℓôř !!!]",
  header_education_message: "[!!! Hèáδèř Éδúçáƭïôñ Mèƨƨáϱè ℓôřè₥  !!!]",
  footer_education_message: "[!!! Fôôƭèř Éδúçáƭïôñ Mèƨƨáϱè ℓôřè₥  !!!]",
  preview: "[!!! ÞřèƲïèω ℓ !!!]",

  // Certificate Headers
  congrats_message:
    "Ýôúř WïFï ïñƨƭáℓℓáƭïôñ ïƨ çô₥ƥℓèƭè áñδ λáƨ βèèñ çèřƭïƒïèδ β¥ RôúƭèTλïƨ! ℓôřè₥ ïƥƨú₥ δôℓôř ƨï",
  installation_details: "Ìñƨƭáℓℓáƭïôñ Ðèƭáïℓƨ ℓôřè₥",
  wireless_speed_test: "Wïřèℓèƨƨ §ƥèèδ Tèƨƭ ℓôřè₥",
  wireless_performance: "[!!! Wïřèℓèƨƨ Þèřƒôř₥áñçè ℓôřè₥ !!!]",
  photos: "Þλôƭôƨ ℓ",
  signal_maps: "§ïϱñáℓ Máƥƨ ℓô",
  wifi_information: "[!!! WïFï Ìñƒôř₥áƭïôñ ℓôřè !!!]",

  // Certificate Room Names
  singular_room: "Rôô₥",
  room_type_bathroom: "ßáƭλřôô₥ ℓ",
  room_type_bedroom: "ßèδřôô₥ ℓ",
  room_type_dining_room: "Ðïñïñϱ Rôô₥ ℓô",
  room_type_entry_or_hall: "Éñƭř¥/Háℓℓ ℓô",
  room_type_garage: "Gářáϱè ℓ",
  room_type_kitchen: "Kïƭçλèñ ℓ",
  room_type_living_room: "£ïƲïñϱ Rôô₥ ℓô",
  room_type_office: "Óƒƒïçè ℓ",
  room_type_other: "Óƭλèř ℓ",

  // Pod Name
  pod_1: "[!!! Mèƨλ Þôδ ℓ !!!]",
  pod_2: "[!!! Âççèƨƨ Þôïñƭ ℓôř !!!]",
  pod_3: "[!!! Mèƨλ Nôδè ℓô !!!]",
  pod_4: "[!!! Mèƨλ Þúçƙ ℓô !!!]",
  pod_5: "[!!! ßèáçôñ ℓ !!!]",
  pod_6: "[!!! Ráñϱè Éжƭèñδèř ℓôř !!!]",
  pods_1: "[!!! Mèƨλ Þôδƨ ℓô !!!]",
  pods_2: "[!!! Âççèƨƨ Þôïñƭƨ ℓôř !!!]",
  pods_3: "[!!! Mèƨλ Nôδèƨ ℓô !!!]",
  pods_4: "[!!! Mèƨλ Þúçƙƨ ℓô !!!]",
  pods_5: "[!!! ßèáçôñƨ ℓ !!!]",
  pods_6: "[!!! Ráñϱè Éжƭèñδèřƨ ℓôřè !!!]",

  // Router Name
  router_1: "[!!! Rôúƭèř ℓ !!!]",
  router_2: "[!!! Môδè₥ ℓ !!!]",
  router_3: "[!!! Gáƭèωá¥ ℓ !!!]",
  router_4: "[!!! Húβ  !!!]",
  router_5: "[!!! Rèƨïδèñƭïáℓ Gáƭèωá¥ ℓôřè₥ !!!]",

  // Level Name
  level_1: "£èƲèℓ ℓ",
  level_2: "Fℓôôř ℓ",
  levels_1: "£èƲèℓƨ ℓ",
  levels_2: "Fℓôôřƨ ℓ",

  // a11y Labels
  go_to_homepage: "[!!! Gô ƭô λô₥èƥáϱè ℓôř !!!]",
  edit_user_x: "[!!! Éδïƭ úƨèř [X] ℓôř !!!]",
  open_certificate_for_addr: "[!!! Óƥèñ çèřƭïƒïçáƭè ƒôř [ADDR] ℓôřè₥ ï !!!]",
  clear_all_filters: "[!!! Çℓèář áℓℓ ƒïℓƭèřƨ ℓôřè !!!]",
  expand_sidebar: "[!!! Éжƥáñδ ƨïδèβář ℓôř !!!]",
  current_tenant_branding_image:
    "[!!! Çúřřèñƭ ƭèñáñƭ βřáñδïñϱ ï₥áϱè ℓôřè₥ ïƥ !!!]",
  new_tenant_branding_image: "[!!! Nèω ƭèñáñƭ βřáñδïñϱ ï₥áϱè ℓôřè₥ ï !!!]",

  // Certificate Pod Info
  recommended: "Rèçô₥₥èñδèδ ℓô",
  installed: "Ìñƨƭáℓℓèδ ℓô",
  total: "Tôƭáℓ ℓ",

  // Certificate Signal Table
  front_building: "Fřôñƭ ôƒ ßúïℓδïñϱ ℓôřè",
  speed: "§ƥèèδ ℓ",
  video: "Vïδèô ℓ",
  rssi: "R§§Ì",
  rssi_description: "δß₥",
  link: "£ïñƙ",
  frequency_short: "Fřè9. ℓ",
  frequency_description: "MHƺ",
  channel_short: "Çλ.",

  // Certificate Legend
  legend: "£èϱèñδ ℓ",
  measured_speed: "Mèáƨúřèδ §ƥèèδ ℓôř",
  measured_speed_description: "Mβƥƨ",

  // Certificate Speedtest Result
  speedtest_passed:
    "§ƥèèδ ïƨ ωïƭλïñ ƭλè èжƥèçƭèδ řáñϱè ƒôř ₥ôƨƭ ₥ôβïℓè δèƲïçèƨ. Nôƭ áℓℓ ωïřèℓèƨƨ δèƲïçèƨ ářè çáƥáβℓè ôƒ řèáçλïñϱ ₥áжï₥ú₥ ƥℓáñ ƨƥèèδ. §èè βèℓôω ƒôř ïñδïƲïδúáℓ řôô₥ ƭèƨƭƨ. ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ á₥èƭ, çôñƨèçƭèƭúř áδïƥïƨçïñ",
  speedtest_failed:
    "Tèƨƭèδ ôñ á ƥλôñè ôř ƭáβℓèƭ. Nôƭ áℓℓ ωïřèℓèƨƨ δèƲïçèƨ ářè çáƥáβℓè ôƒ řèáçλïñϱ ₥áжï₥ú₥ ƥℓáñ ƨƥèèδ. §èè βèℓôω ƒôř ïñδïƲïδúáℓ řôô₥ ƭèƨƭƨ. ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ á₥èƭ, çôñƨèçƭèƭúř",
  speedtestmessages_strong:
    "[Spééd ís wíthin thé éxpéctéd rángé fór móst móbílé dévícés.]",
  speedtestmessages_weak:
    "[Spééd ís fár bélów thé éxpéctéd rángé fór móst móbílé dévícés.]",
  speedtestmessages_medium:
    "[Spééd ís bélów thé éxpéctéd rángé fór móst móbílé dévícés.]",
  wifi_activities_highspeed_videos: "[Múltíplé 4K Vídeós]",
  wifi_activities_highspeed_conferencing: "[Vídeó Cónféréncíng]",
  wifi_activities_highspeed_gaming: "[Ónlíne Gámíng]",
  wifi_activities_highspeed_music: "[Stréámíng Músíc]",
  wifi_activities_lowspeed_conferencing: "[Vídeó Cónféréncíng]",
  wifi_activities_lowspeed_gaming: "[Ónlíne Gámíng]",
  wifi_activities_lowspeed_music: "[Stréámíng Músíc]",
  wifi_activities_lowspeed_email: "[Émáíl & Sócíál M édíá]",
  speedTestIndicatorText_weak: "[Póór WíFí Spééd]",
  speedTestIndicatorText_medium: "[Slówér WíFí Spééd]",
  speedTestIndicatorText_strong: "[Óptímál WíFí Spééd]",
  signal_coverage: "[Sígnál C óvérágé]",
  signaltablemessage_title:
    "[Áctívítíés áré árrángéd léft tó ríght by réqúíréd sígnál stréngth.]",
  signaltablemessage_subtitle:
    "[Íf yóú cán pérf órm án áctívítý ín thé índícátéd róóm, yóú cán álsó pérf órm áll áctívítíés tó íts ríght.]",
  alerts: "[Álérts]",
  alertMessages_bandAlert:
    "[Spéédtést wás rún ón 2.4GHz bánd; slów spééd réc órdéd.]",
  alertMessages_lowSignalAlert:
    "[Y óúr c ónnéct íón héré wíll bé stáblé ánd áll ów yóú tó br ówsé bóth émáíl ánd sócíál médíá, bút yóú wíll nót éxpéríéncé thé spééds áváíláblé ín óthér párts óf yóúr h ómé.]",
  alertMessages_veryLowSignalAlert:
    "[Y óúr sígnál stréngth ís véry p ó ór. Y óú máy éxpéríéncé slów lóádíng t ímés ánd ínt érrúpt íóns. Fór á bétt ér éxpéríéncé, móvé tó á díff érént párt óf yóúr h ómé whéré thé sígnál ís str óngér.]",
  alertMessages_noAlert: "[N ó álérts ón th ís lévél!]",
  alertmessages_lowPodsAlert:
    "[Síncé n ót áll thé réc ómm éndéd p óds wéré ínstálléd, y óú máy éxpéríéncé á rédúct íón ín spééds ás yóú gét f árthér áwáy fróm thé róútér.]",
  customLowPodsAlertString:
    "[Síncé n ót áll thé réc ómm éndéd %PODSNAME wéré ínstálléd, y óú máy éxpéríéncé á rédúct íón ín spééds ás yóú gét f árthér áwáy fróm thé %ROUTERNAME.]",

  // Login/Reset Password
  email: "[!!! É₥áïℓ ℓ !!!]",
  password: "[!!! Þáƨƨωôřδ ℓ !!!]",
  sign_in: "[!!! §ïϱñ Ìñ ℓ !!!]",
  forgot_password: "[!!! Fôřϱôƭ Þáƨƨωôřδ ℓôřè !!!]",
  reset_password: "[!!! Rèƨèƭ Þáƨƨωôřδ ℓôř !!!]",
  reset_password_instructions:
    "[!!! Tô řèƨèƭ ¥ôúř ƥáƨƨωôřδ, èñƭèř ¥ôúř è₥áïℓ áδδřèƨƨ áβôƲè áñδ ωè'ℓℓ ƨèñδ ïñƨƭřúçƭïôñƨ, ïƒ ƭλè áççôúñƭ èжïƨƭƨ. ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ á₥èƭ, çôñ !!!]",
  sent_reset_password_code:
    "[!!! Wè ƨèñƭ á ƥáƨƨωôřδ řèƨèƭ çôδè ƭô [è₥áïℓ] Éñƭèř ƭλáƭ çôδè áñδ á ñèω ƥáƨƨωôřδ. ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ  !!!]",
  reset_code: "[!!! Rèƨèƭ Çôδè ℓô !!!]",
  new_password: "[!!! Nèω Þáƨƨωôřδ ℓôř !!!]",
  reenter_new_password: "[!!! Rè-èñƭèř Nèω Þáƨƨωôřδ ℓôřè₥ !!!]",
  must_include_email: "[!!! Múƨƭ ïñçℓúδè è₥áïℓ ℓôřè !!!]",
  old_password: "[!!! Óℓδ Þáƨƨωôřδ ℓôř !!!]",
  set_new_password: "[!!! §èƭ Nèω Þáƨƨωôřδ ℓôřè !!!]",
  password_expired: "[!!! Þáƨƨωôřδ Éжƥïřèδ ℓôřè !!!]",
  change_your_password: "[!!! Çλáñϱè Ýôúř Þáƨƨωôřδ ℓôřè₥ !!!]",
  change_password: "[!!! Çλáñϱè Þáƨƨωôřδ ℓôřè !!!]",
  set_password: "[!!! §èƭ Þáƨƨωôřδ ℓôř !!!]",

  // Users List
  new_user: "[!!! Nèω Ûƨèř ℓ !!!]",
  edit_user: "[!!! Éδïƭ Ûƨèř ℓô !!!]",
  bulk_import: "[!!! ßúℓƙ Ì₥ƥôřƭ ℓô !!!]",
  show_disabled_users: "[!!! §λôω Ðïƨáβℓèδ Ûƨèřƨ ℓôřè₥ !!!]",
  name: "[!!! Ná₥è  !!!]",
  role: "[!!! Rôℓè  !!!]",

  // Valid User roles
  user_role: "[!!! úƨèř  !!!]",
  tenant_admin_role: "[!!! TèñáñƭÂδ₥ïñ ℓô !!!]",
  super_admin_role: "[!!! §úƥèřÂδ₥ïñ ℓô !!!]",
  tenant_admin: "[!!! Tèñáñƭ Âδ₥ïñ ℓôř !!!]",
  super_admin: "[!!! §úƥèř Âδ₥ïñ ℓô !!!]",

  // Create/Edit User Modal
  email_required: "[!!! É₥áïℓ (Rè9úïřèδ) ℓôřè !!!]",
  first_name: "[!!! Fïřƨƭ Ná₥è ℓô !!!]",
  last_name: "[!!! £áƨƭ Ná₥è ℓô !!!]",
  force_password_reset: "[!!! Fôřçè Þáƨƨωôřδ Rèƨèƭ ℓôřè₥ !!!]",
  resend_validation_code: "[!!! Rèƨèñδ Váℓïδáƭïôñ Çôδè ℓôřè₥  !!!]",
  enable_user: "[!!! Éñáβℓè Ûƨèř ℓô !!!]",
  disable_user: "[!!! Ðïƨáβℓè Ûƨèř ℓôř !!!]",
  certify: "[!!! Çèřƭïƒ¥ ℓ !!!]",
  unverified: "[!!! ÛñƲèřïƒïèδ ℓô !!!]",
  locked_out: "[!!! £ôçƙèδ Óúƭ ℓô !!!]",
  disabled: "[!!! Ðïƨáβℓèδ ℓ !!!]",
  reset_user_password_confirmation:
    "[!!! Âřè ¥ôú ƨúřè ¥ôú ωáñƭ ƭô řèƨèƭ ƭλïƨ úƨèř'ƨ ƥáƨƨωôřδ? ℓôřè₥ ïƥƨú₥ δôℓ !!!]",
  resend_validation_code_confirmation:
    "[!!! Âřè ¥ôú ƨúřè ¥ôú ωáñƭ ƭô řèƨèñδ Ʋáℓïδáƭïôñ çôδè? ℓôřè₥ ïƥƨú₥ δ !!!]",
  cannot_disable_yourself: "[!!! Çáññôƭ δïƨáβℓè ¥ôúřƨèℓƒ ℓôřè₥  !!!]",
  cancel_changes: "[!!! Çáñçèℓ çλáñϱèƨ ℓôř !!!]",

  // Bulk Import Modal
  csv_format_requirements:
    "[!!! Ç§V Fôř₥áƭ: è₥áïℓ, ƒïřƨƭNá₥è, ℓáƨƭNá₥è, řôℓè (ôñℓ¥ è₥áïℓ ïƨ řè9úïřèδ) ℓôřè₥ ïƥƨú₥ δôℓôř ƨï !!!]",
  valid_user_roles:
    '[!!! Váℓïδ úƨèř řôℓèƨ: "úƨèř", "TèñáñƭÂδ₥ïñ", "§úƥèřÂδ₥ïñ" ℓôřè₥ ïƥƨú₥ δôℓ !!!]',
  select_csv: "[!!! §èℓèçƭ Ç§V ℓô !!!]",
  import: "[!!! Ì₥ƥôřƭ ℓ !!!]",
  file_too_large:
    "[!!! Fïℓè ƭôô ℓářϱè (Máжï₥ú₥ ôƒ ÌMÞÓRT_£ÌMÌT úƨèřƨ) ℓôřè₥ ïƥƨú₥ δ !!!]",
  required_headers_missing:
    "[!!! Rè9úïřèδ λèáδèřƨ ₥ïƨƨïñϱ: è₥áïℓ ℓôřè₥ ïƥ !!!]",
  user_import_starting:
    "[!!! Ûƨèř ï₥ƥôřƭ ƨƭářƭïñϱ. Ýôú ωïℓℓ řèçèïƲè áñ ï₥ƥôřƭ ƨú₥₥ář¥ è₥áïℓ ïñ á ƒèω ₥ïñúƭèƨ. ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ á !!!]",

  // Tenant Main Settings
  email_language: "[!!! É₥áïℓ £áñϱúáϱè ℓôř !!!]",
  country: "[!!! Çôúñƭř¥ ℓ !!!]",
  description_optional: "[!!! Ðèƨçřïƥƭïôñ (Óƥƭïôñáℓ) ℓôřè₥  !!!]",
  units_feet_meters: "[!!! Ûñïƭƨ (Fèèƭ, Mèƭèřƨ) ℓôřè₥ !!!]",
  certify_id: "[!!! Çèřƭïƒ¥ ÌÐ ℓô !!!]",
  resolve_id: "[!!! RèƨôℓƲè ÌÐ ℓô !!!]",
  sms_settings: "[!!! §₥ƨ §èƭƭïñϱƨ ℓô !!!]",
  sms_from: "[!!! §M§ Fřô₥ ℓ !!!]",
  sms_body: "[!!! §M§ ßôδ¥ ℓ !!!]",
  default_sms_body:
    "[!!! Ýôúř WïFï ïñƨƭáℓℓáƭïôñ ïƨ çô₥ƥℓèƭè áñδ λáƨ βèèñ çèřƭïƒïèδ β¥ [NÂMÉ]! ℓôřè₥ ïƥƨú₥ δôℓôř ƨ Vïèω ¥ôúř çèřƭïƒïçáƭè λèřè: [£ÌNK] ℓôřè₥ ïƥƨ !!!]",
  sms_body_helper_text:
    "[!!! Çèřƭïƒ¥ ωïℓℓ ƭèжƭ ƭλïƨ ₥èƨƨáϱè ƭô ƭλè çúƨƭô₥èř. [£ÌNK] ωïℓℓ βè řèƥℓáçèδ ωïƭλ á ℓïñƙ ƭô ƭλè çèřƭïƒïçáƭè (řè9úïřèδ). [NÂMÉ] ωïℓℓ βè řèƥℓáçèδ ωïƭλ ƭλè çôñƭèñƭƨ ôƒ ƭλè Ná₥è ƒïèℓδ (ôƥƭïôñáℓ) ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ á₥èƭ, çôñƨèçƭèƭúř áδïƥïƨçïñϱ èℓïƭ !!!]",
  link_must_be_in_sms_body:
    "[!!! [£ÌNK] ₥úƨƭ βè ïñ ƭλè §M§ βôδ¥. ℓôřè₥ ïƥ !!!]",
  update_successful: "[!!! Ûƥδáƭè §úççèƨƨƒúℓ ℓôřè !!!]",
  creation_successful: "[!!! Çřèáƭïôñ §úççèƨƨƒúℓ ℓôřè₥ !!!]",

  // Tenant Terminology Settings
  term: "[!!! Tèř₥  !!!]",
  example_usage: "[!!! Éжá₥ƥℓè Ûƨáϱè ℓôř !!!]",
  customer_example_usage_1:
    "[!!! Ìñ çôñƨúℓƭáƭïôñ ωïƭλ ƭλè çúƨƭô₥èř, çôñƒïř₥ ƭλè ƨèℓèçƭèδ βúïℓδïñϱ, ôř ϱô βáçƙ ƭô èδïƭ ƭλè áδδřèƨƨ. ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ á₥èƭ,  !!!]",
  customer_example_usage_2:
    "[!!! Ìñ çôñƨúℓƭáƭïôñ ωïƭλ ƭλè ƨúβƨçřïβèř, çôñƒïř₥ ƭλè ƨèℓèçƭèδ βúïℓδïñϱ, ôř ϱô βáçƙ ƭô èδïƭ ƭλè áδδřèƨƨ. ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ á₥èƭ, ç !!!]",
  router_example_usage_1:
    "[!!! Táƥ ƭλè ƥřôƥôƨèδ řôúƭèř ℓôçáƭïôñ βèℓôω. ℓôřè₥ ïƥƨú₥ !!!]",
  router_example_usage_2:
    "[!!! Táƥ ƭλè ƥřôƥôƨèδ ₥ôδè₥ ℓôçáƭïôñ βèℓôω. ℓôřè₥ ïƥƨú !!!]",
  router_example_usage_3:
    "[!!! Táƥ ƭλè ƥřôƥôƨèδ ϱáƭèωá¥ ℓôçáƭïôñ βèℓôω. ℓôřè₥ ïƥƨú₥ !!!]",
  router_example_usage_4:
    "[!!! Táƥ ƭλè ƥřôƥôƨèδ λúβ ℓôçáƭïôñ βèℓôω. ℓôřè₥ ïƥƨú !!!]",
  router_example_usage_5:
    "[!!! Táƥ ƭλè ƥřôƥôƨèδ řèƨïδèñƭïáℓ ϱáƭèωá¥ ℓôçáƭïôñ βèℓôω. ℓôřè₥ ïƥƨú₥ δôℓ !!!]",
  level_example_usage_1:
    "[!!! Gô ƭô ℓèƲèℓ 2 áñδ ƭáƥ ¥ôúř ℓôçáƭïôñ. ℓôřè₥ ïƥƨú !!!]",
  level_example_usage_2:
    "[!!! Gô ƭô ƒℓôôř 2 áñδ ƭáƥ ¥ôúř ℓôçáƭïôñ. ℓôřè₥ ïƥƨú !!!]",
  mesh_pod_example_usage_1:
    "[!!! Éƨƭï₥áƭïñϱ ƨïϱñáℓ ƨƭřèñϱƭλ áñδ ôƥƭï₥ú₥ ₥èƨλ ƥôδ ƥℓáçè₥èñƭ. ℓôřè₥ ïƥƨú₥ δôℓô !!!]",
  mesh_pod_example_usage_2:
    "[!!! Éƨƭï₥áƭïñϱ ƨïϱñáℓ ƨƭřèñϱƭλ áñδ ôƥƭï₥ú₥ áççèƨƨ ƥôïñƭ ƥℓáçè₥èñƭ. ℓôřè₥ ïƥƨú₥ δôℓôř  !!!]",
  mesh_pod_example_usage_3:
    "[!!! Éƨƭï₥áƭïñϱ ƨïϱñáℓ ƨƭřèñϱƭλ áñδ ôƥƭï₥ú₥ ₥èƨλ ñôδè ƥℓáçè₥èñƭ. ℓôřè₥ ïƥƨú₥ δôℓôř !!!]",
  mesh_pod_example_usage_4:
    "[!!! Éƨƭï₥áƭïñϱ ƨïϱñáℓ ƨƭřèñϱƭλ áñδ ôƥƭï₥ú₥ ₥èƨλ ƥúçƙ ƥℓáçè₥èñƭ. ℓôřè₥ ïƥƨú₥ δôℓôř !!!]",
  mesh_pod_example_usage_5:
    "[!!! Éƨƭï₥áƭïñϱ ƨïϱñáℓ ƨƭřèñϱƭλ áñδ ôƥƭï₥ú₥ βèáçôñ ƥℓáçè₥èñƭ. ℓôřè₥ ïƥƨú₥ δôℓô !!!]",
  mesh_pod_example_usage_6:
    "[!!! Éƨƭï₥áƭïñϱ ƨïϱñáℓ ƨƭřèñϱƭλ áñδ ôƥƭï₥ú₥ řáñϱè èжƭèñδèř ƥℓáçè₥èñƭ. ℓôřè₥ ïƥƨú₥ δôℓôř  !!!]",
  wifi_example_usage_1: "[!!! WïFï Máƥƥïñϱ ℓôř !!!]",
  wifi_example_usage_2: "[!!! Wï-Fï Máƥƥïñϱ ℓôř !!!]",
  wifi_example_usage_3: "[!!! Wïƒï Máƥƥïñϱ ℓôř !!!]",
  wifi_example_usage_4: "[!!! WÌFÌ Máƥƥïñϱ ℓôř !!!]",

  // Tenant Equipment Settings (Certify)
  router_options_1: "[!!! Rôúƭèř Óƥƭïôñƨ ℓôř !!!]",
  router_options_2: "[!!! Môδè₥ Óƥƭïôñƨ ℓôř !!!]",
  router_options_3: "[!!! Gáƭèωá¥ Óƥƭïôñƨ ℓôřè !!!]",
  router_options_4: "[!!! Húβ Óƥƭïôñƨ ℓô !!!]",
  router_options_5: "[!!! Rèƨïδèñƭïáℓ Gáƭèωá¥ Óƥƭïôñƨ ℓôřè₥ ï !!!]",
  new_router_options_1: "[!!! Nèω Rôúƭèř Óƥƭïôñƨ ℓôřè !!!]",
  new_router_options_2: "[!!! Nèω Môδè₥ Óƥƭïôñƨ ℓôřè !!!]",
  new_router_options_3: "[!!! Nèω Gáƭèωá¥ Óƥƭïôñƨ ℓôřè₥ !!!]",
  new_router_options_4: "[!!! Nèω Húβ Óƥƭïôñƨ ℓôřè !!!]",
  new_router_options_5: "[!!! Nèω Rèƨïδèñƭïáℓ Gáƭèωá¥ Óƥƭïôñƨ ℓôřè₥ ïƥ !!!]",
  mesh_pod_options_1: "[!!! Mèƨλ Þôδ Óƥƭïôñƨ ℓôřè !!!]",
  mesh_pod_options_2: "[!!! Âççèƨƨ Þôïñƭ Óƥƭïôñƨ ℓôřè₥ !!!]",
  mesh_pod_options_3: "[!!! Mèƨλ Nôδè Óƥƭïôñƨ ℓôřè !!!]",
  mesh_pod_options_4: "[!!! Mèƨλ Þúçƙ Óƥƭïôñƨ ℓôřè !!!]",
  mesh_pod_options_5: "[!!! ßèáçôñ Óƥƭïôñƨ ℓôř !!!]",
  mesh_pod_options_6: "[!!! Ráñϱè Éжƭèñδèř Óƥƭïôñƨ ℓôřè₥  !!!]",
  new_mesh_pod_options_1: "[!!! Nèω Mèƨλ Þôδ Óƥƭïôñƨ ℓôřè₥ !!!]",
  new_mesh_pod_options_2: "[!!! Nèω Âççèƨƨ Þôïñƭ Óƥƭïôñƨ ℓôřè₥  !!!]",
  new_mesh_pod_options_3: "[!!! Nèω Mèƨλ Nôδè Óƥƭïôñƨ ℓôřè₥ !!!]",
  new_mesh_pod_options_4: "[!!! Nèω Mèƨλ Þúçƙ Óƥƭïôñƨ ℓôřè₥ !!!]",
  new_mesh_pod_options_5: "[!!! Nèω ßèáçôñ Óƥƭïôñƨ ℓôřè !!!]",
  new_mesh_pod_options_6: "[!!! Nèω Ráñϱè Éжƭèñδèř Óƥƭïôñƨ ℓôřè₥ ï !!!]",
  missing_required_router_info_1:
    "[!!! Mïƨƨïñϱ Rè9úïřèδ Rôúƭèř Ìñƒô ℓôřè₥ ï !!!]",
  missing_required_router_info_2:
    "[!!! Mïƨƨïñϱ Rè9úïřèδ Môδè₥ Ìñƒô ℓôřè₥ ï !!!]",
  missing_required_router_info_3:
    "[!!! Mïƨƨïñϱ Rè9úïřèδ Gáƭèωá¥ Ìñƒô ℓôřè₥ ïƥ !!!]",
  missing_required_router_info_4: "[!!! Mïƨƨïñϱ Rè9úïřèδ Húβ Ìñƒô ℓôřè₥ ï !!!]",
  missing_required_router_info_5:
    "[!!! Mïƨƨïñϱ Rè9úïřèδ Rèƨïδèñƭïáℓ Gáƭèωá¥ Ìñƒô ℓôřè₥ ïƥƨú₥ !!!]",
  missing_required_mesh_pod_info_1:
    "[!!! Mïƨƨïñϱ Rè9úïřèδ Mèƨλ Þôδ Ìñƒô ℓôřè₥ ïƥ !!!]",
  missing_required_mesh_pod_info_2:
    "[!!! Mïƨƨïñϱ Rè9úïřèδ Âççèƨƨ Þôïñƭ Ìñƒô ℓôřè₥ ïƥƨ !!!]",
  missing_required_mesh_pod_info_3:
    "[!!! Mïƨƨïñϱ Rè9úïřèδ Mèƨλ Nôδè Ìñƒô ℓôřè₥ ïƥ !!!]",
  missing_required_mesh_pod_info_4:
    "[!!! Mïƨƨïñϱ Rè9úïřèδ Mèƨλ Þúçƙ Ìñƒô ℓôřè₥ ïƥ !!!]",
  missing_required_mesh_pod_info_5:
    "[!!! Mïƨƨïñϱ Rè9úïřèδ ßèáçôñ Ìñƒô ℓôřè₥ ï !!!]",
  missing_required_mesh_pod_info_6:
    "[!!! Mïƨƨïñϱ Rè9úïřèδ Ráñϱè Éжƭèñδèř Ìñƒô ℓôřè₥ ïƥƨú !!!]",
  description: "[!!! δèƨçřïƥƭïôñ ℓô !!!]",
  display_name: "[!!! Ðïƨƥℓá¥ Ná₥è ℓôř !!!]",
  range_in_unit_1: "[!!! Ráñϱè ïñ Fèèƭ ℓôř !!!]",
  range_in_unit_2: "[!!! Ráñϱè ïñ Mèƭèřƨ ℓôřè !!!]",
  area_in_unit_1: "[!!! Âřèá ïñ §9úářè Fèèƭ ℓôřè₥ !!!]",
  area_in_unit_2: "[!!! Âřèá ïñ §9úářè Mèƭèřƨ ℓôřè₥ !!!]",
  default_active: "[!!! Ðèƒáúℓƭ ÂçƭïƲè ℓôř !!!]",
  average_range: "[!!! ÂƲèřáϱè Ráñϱè ℓôř !!!]",
  certify_default: "[!!! Çèřƭïƒ¥ δèƒáúℓƭ ℓôřè !!!]",
  default: "[!!! Ðèƒáúℓƭ ℓ !!!]",
  active: "[!!! ÂçƭïƲè ℓ !!!]",
  one_option_must_be_default: "[!!! Óñè ôƥƭïôñ ₥úƨƭ βè δèƒáúℓƭ ℓôřè₥ ï !!!]",
  set_as_default: "[!!! §èƭ áƨ δèƒáúℓƭ ℓôř !!!]",
  default_option_must_be_active:
    "[!!! Ðèƒáúℓƭ ôƥƭïôñ ₥úƨƭ βè áçƭïƲè ℓôřè₥ ïƥ !!!]",
  deactivate: "[!!! ÐèáçƭïƲáƭè ℓô !!!]",
  activate: "[!!! ÂçƭïƲáƭè ℓ !!!]",
  name_is_required: "[!!! Ná₥è ïƨ řè9úïřèδ ℓôřè !!!]",

  // Customer Name
  customer_1: "[!!! Çúƨƭô₥èř ℓ !!!]",
  customer_2: "[!!! §úβƨçřïβèř ℓô !!!]",

  // Wifi Name
  wifi_1: "[!!! WïFï  !!!]",
  wifi_2: "[!!! Wï-Fï ℓ !!!]",
  wifi_3: "[!!! Wïƒï  !!!]",
  wifi_4: "[!!! WÌFÌ  !!!]",

  // Units
  units_1: "[!!! Fèèƭ  !!!]",
  units_2: "[!!! Mèƭèřƨ ℓ !!!]",

  // Misc
  confirm: "[!!! Çôñƒïř₥ ℓ !!!]",
  units: "[!!! Ûñïƭƨ ℓ !!!]",
  region: "[!!! Rèϱïôñ ℓ !!!]",
  edit: "[!!! Éδïƭ  !!!]",
  modified: "[!!! Môδïƒïèδ ℓ !!!]",
  create: "[!!! Çřèáƭè ℓ !!!]",
  created: "[!!! Çřèáƭèδ ℓ !!!]",
  routethis_app: "[!!! RôúƭèTλïƨ Âƥƥ ℓôř !!!]",
  loading: "[!!! £ôáδïñϱ... ℓô !!!]",
  redirecting: "[!!! Rèδïřèçƭïñϱ... ℓôř !!!]",
  error: "[!!! Éřřôř ℓ !!!]",
  close: "[!!! Çℓôƨè ℓ !!!]",

  // Languages
  en: "[!!! Éñϱℓïƨλ (Û§) ℓôř !!!]",
  "en-GB": "[!!! Éñϱℓïƨλ (Gß) ℓôř !!!]",
  da: "[!!! Ðáñïƨλ ℓ !!!]",
  fi: "[!!! Fïññïƨλ ℓ !!!]",
  fr: "[!!! Fřèñçλ ℓ !!!]",
  "fr-CA": "[!!! Fřèñçλ (Çáñáδá) ℓôřè !!!]",
  de: "[!!! Gèř₥áñ ℓ !!!]",
  el: "[!!! Gřèèƙ ℓ !!!]",
  it: "[!!! Ìƭáℓïáñ ℓ !!!]",
  pt: "[!!! Þôřƭúϱúèƨè ℓô !!!]",
  "pt-BR": "[!!! Þôřƭúϱúèƨè (ßřáƺïℓ ℓôřè !!!]",
  es: "[!!! §ƥáñïƨλ ℓ !!!]",
  "es-419": "[!!! §ƥáñïƨλ (£áƭïñ Â₥èřïçá) ℓôřè₥  !!!]",
  sv: "[!!! §ωèδïƨλ ℓ !!!]",
};

export const en_XA_errors = {
  // Client-side validation errors
  incorrect_email_or_password:
    "[!!! Ìñçôřřèçƭ è₥áïℓ ôř ƥáƨƨωôřδ, ôř δïƨáβℓèδ áççôúñƭ. Tř¥ áϱáïñ ôř çôñƭáçƭ áñ áδ₥ïñïƨƭřáƭôř. ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ á₥è !!!]",
  invalid_reset_code: "[!!! ÌñƲáℓïδ řèƨèƭ çôδè ℓôřè !!!]",
  password_minimum_requirements:
    "[!!! Ýôúř ƥáƨƨωôřδ ₥úƨƭ βè á ₥ïñï₥ú₥ ôƒ 8 çλářáçƭèřƨ áñδ ïñçℓúδè áƭ ℓèáƨƭ ôñè ℓôωèřçáƨè, ôñè úƥƥèřçáƨè, áñδ ôñè ñú₥èřïç çλářáçƭèř. ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ á₥èƭ, çôñƨèçƭèƭ !!!]",
  passwords_must_match: "[!!! Þáƨƨωôřδƨ ₥úƨƭ ₥áƭçλ ℓôřè₥ !!!]",
  must_include_new_password_email:
    "[!!! Múƨƭ ïñçℓúδè ñèω ƥáƨƨωôřδ áñδ úƨèř è₥áïℓ ℓôřè₥ ïƥƨú₥ !!!]",
  must_include_new_password_confirmation_code:
    "[!!! Múƨƭ ïñçℓúδè ñèω ƥáƨƨωôřδ áñδ çôñƒïř₥áƭïôñÇôδè ℓôřè₥ ïƥƨú₥ δ !!!]",
  cannot_send_reset_code_without_email:
    "[!!! Çáññôƭ ƨèñδ řèƨèƭ çôδè ωïƭλôúƭ è₥áïℓ ℓôřè₥ ïƥƨú !!!]",
  must_enter_old_password: "[!!! Múƨƭ èñƭèř Óℓδ Þáƨƨωôřδ ℓôřè₥  !!!]",
  must_enter_reset_code: "[!!! Múƨƭ èñƭèř Rèƨèƭ Çôδè ℓôřè₥ !!!]",
  must_enter_new_password: "[!!! Múƨƭ èñƭèř Nèω Þáƨƨωôřδ ℓôřè₥  !!!]",
  passwords_cannot_begin_or_end_with_spaces:
    "[!!! Þáƨƨωôřδƨ çáññôƭ βèϱïñ ôř èñδ ωïƭλ ƨƥáçèƨ ℓôřè₥ ïƥƨú₥ !!!]",

  // Server-side errors
  "User with that email already exists":
    "[!!! Ûƨèř ωïƭλ ƭλáƭ è₥áïℓ áℓřèáδ¥ èжïƨƭƨ ℓôřè₥ ïƥƨú !!!]",
  "Try another display name": "[!!! Tř¥ áñôƭλèř δïƨƥℓá¥ ñá₥è ℓôřè₥  !!!]",
  "Password cannot be a previously used password":
    "[!!! 'Þáƨƨωôřδ çáññôƭ βè á ƥřèƲïôúƨℓ¥ úƨèδ ƥáƨƨωôřδ' ℓôřè₥ ïƥƨú₥ δ !!!]",
  "Invalid reset code": "[!!! ÌñƲáℓïδ řèƨèƭ çôδè ℓôřè !!!]",
  "Wrong username and password combination or the user does not exist.":
    "[!!! Ìñçôřřèçƭ è₥áïℓ ôř ƥáƨƨωôřδ, ôř δïƨáβℓèδ áççôúñƭ. Tř¥ áϱáïñ ôř çôñƭáçƭ áñ áδ₥ïñïƨƭřáƭôř. ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ á₥è !!!]",
  "Invalid code provided, please request a code again.":
    "[!!! ÌñƲáℓïδ çôδè ƥřôƲïδèδ, ƥℓèáƨè řè9úèƨƭ á çôδè áϱáïñ. ℓôřè₥ ïƥƨú₥ δô !!!]",
  "Password cannot begin or end with spaces":
    "[!!! Þáƨƨωôřδƨ çáññôƭ βèϱïñ ôř èñδ ωïƭλ ƨƥáçèƨ ℓôřè₥ ïƥƨú₥ !!!]",
  "LimitExceededException - Attempt limit exceeded, please try after some time.":
    "[!!! Âƭƭè₥ƥƭ ℓï₥ïƭ èжçèèδèδ, ƥℓèáƨè ƭř¥ áƒƭèř ƨô₥è ƭï₥è. ℓôřè₥ ïƥƨú₥ δô !!!]",
  "User is not Authorized": "[!!! Ûƨèř ïƨ ñôƭ Âúƭλôřïƺèδ ℓôřè₥  !!!]",
  "Your session timed out. Sign in again with your temporary password.":
    "[!!! Ýôúř ƨèƨƨïôñ ƭï₥èδ ôúƭ. §ïϱñ ïñ áϱáïñ ωïƭλ ¥ôúř ƭè₥ƥôřář¥ ƥáƨƨωôřδ. ℓôřè₥ ïƥƨú₥ δôℓôř ƨ !!!]",
  "Internal Service Failure - Cognito Unavailable":
    "[!!! Çôϱñïƭô ÛñáƲáïℓáβℓè ℓôřè₥ !!!]",
  "Internal Service Failure - Unknown Failure":
    "[!!! Ûñƙñôωñ Fáïℓúřè ℓôřè !!!]",
  "Must enter Reset Code": "[!!! Múƨƭ èñƭèř Rèƨèƭ Çôδè ℓôřè₥ !!!]",

  // Challenge Responses
  set_password_challenge:
    "[!!! Ýôú ₥úƨƭ ƨèƭ á ñèω ƥáƨƨωôřδ ƭλè ƒïřƨƭ ƭï₥è ¥ôú ƨïϱñ ïñ ƒôř ƨèçúřïƭ¥ ƥúřƥôƨèƨ. ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ  !!!]",
  reset_password_challenge:
    "[!!! Wè ƨèñƭ á ƥáƨƨωôřδ řèƨèƭ çôδè ƭô [EMAIL]. Éñƭèř ƭλáƭ çôδè áñδ á ñèω ƥáƨƨωôřδ. ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ  !!!]",
  set_new_password_challenge:
    "[!!! Ýôúř çô₥ƥáñ¥'ƨ ƥôℓïç¥ řè9úïřèƨ ƭλáƭ ¥ôúř ƥáƨƨωôřδ èжƥïřèƨ áƒƭèř ƨô₥è ƭï₥è. Wè ƨèñƭ á ƥáƨƨωôřδ řèƨèƭ çôδè ƭô [EMAIL]. Éñƭèř ƭλáƭ çôδè áñδ á ñèω ƥáƨƨωôřδ. ℓôřè₥ ïƥƨú₥ δôℓôř ƨïƭ á₥èƭ, çôñƨèçƭèƭúř áδïƥ !!!]",
  change_your_password_challenge:
    "[!!! Éñƭèř ¥ôúř çúřřèñƭ ƥáƨƨωôřδ áñδ á ñèω ƥáƨƨωôřδ βèℓôω ƭô çλáñϱè ïƭ. ℓôřè₥ ïƥƨú₥ δôℓôř ƨ !!!]",
  change_password_challenge:
    "[!!! Éñƭèř á ñèω ƥáƨƨωôřδ ƒôř ƭλè úƨèř ℓôřè₥ ïƥƨ !!!]",
};

export const en_XA_countries = {
  AF: "[!!! Âƒϱλáñïƨƭáñ ℓô !!!]",
  AX: "[!!! Åℓáñδ Ìƨℓáñδƨ ℓôř !!!]",
  AL: "[!!! Âℓβáñïá ℓ !!!]",
  DZ: "[!!! Âℓϱèřïá ℓ !!!]",
  AS: "[!!! Â₥èřïçáñ §á₥ôá ℓôř !!!]",
  AD: "[!!! Âñδôřřá ℓ !!!]",
  AO: "[!!! Âñϱôℓá ℓ !!!]",
  AI: "[!!! Âñϱúïℓℓá ℓ !!!]",
  AQ: "[!!! Âñƭářçƭïçá ℓô !!!]",
  AG: "[!!! Âñƭïϱúá áñδ ßářβúδá ℓôřè₥ !!!]",
  AR: "[!!! Âřϱèñƭïñá ℓô !!!]",
  AM: "[!!! Âř₥èñïá ℓ !!!]",
  AW: "[!!! Âřúβá ℓ !!!]",
  AU: "[!!! Âúƨƭřáℓïá ℓô !!!]",
  AT: "[!!! Âúƨƭřïá ℓ !!!]",
  AZ: "[!!! ÂƺèřβáïJáñ ℓô !!!]",
  BS: "[!!! ßáλá₥áƨ ℓ !!!]",
  BH: "[!!! ßáλřáïñ ℓ !!!]",
  BD: "[!!! ßáñϱℓáδèƨλ ℓô !!!]",
  BB: "[!!! ßářβáδôƨ ℓ !!!]",
  BY: "[!!! ßèℓářúƨ ℓ !!!]",
  BE: "[!!! ßèℓϱïú₥ ℓ !!!]",
  BZ: "[!!! ßèℓïƺè ℓ !!!]",
  BJ: "[!!! ßèñïñ ℓ !!!]",
  BM: "[!!! ßèř₥úδá ℓ !!!]",
  BT: "[!!! ßλúƭáñ ℓ !!!]",
  BO: "[!!! ßôℓïƲïá (Þℓúřïñáƭïôñáℓ §ƭáƭè ôƒ) ℓôřè₥ ïƥƨ !!!]",
  BQ: "[!!! ßôñáïřè, §ïñƭ Éúƨƭáƭïúƨ áñδ §áβá ℓôřè₥ ïƥƨ !!!]",
  BA: "[!!! ßôƨñïá áñδ HèřƺèϱôƲïñá ℓôřè₥  !!!]",
  BW: "[!!! ßôƭƨωáñá ℓ !!!]",
  BV: "[!!! ßôúƲèƭ Ìƨℓáñδ ℓôř !!!]",
  BR: "[!!! ßřáƺïℓ ℓ !!!]",
  IO: "[!!! ßřïƭïƨλ Ìñδïáñ Óçèáñ Tèřřïƭôř¥ ℓôřè₥ ïƥ !!!]",
  BN: "[!!! ßřúñèï Ðářúƨƨáℓá₥ ℓôřè !!!]",
  BG: "[!!! ßúℓϱářïá ℓ !!!]",
  BF: "[!!! ßúřƙïñá Fáƨô ℓôř !!!]",
  BI: "[!!! ßúřúñδï ℓ !!!]",
  CV: "[!!! Çáβô Vèřδè ℓô !!!]",
  KH: "[!!! Çá₥βôδïá ℓ !!!]",
  CM: "[!!! Çá₥èřôôñ ℓ !!!]",
  CA: "[!!! Çáñáδá ℓ !!!]",
  KY: "[!!! Çá¥₥áñ Ìƨℓáñδƨ ℓôř !!!]",
  CF: "[!!! Çèñƭřáℓ Âƒřïçáñ Rèƥúβℓïç ℓôřè₥  !!!]",
  TD: "[!!! Çλáδ  !!!]",
  CL: "[!!! Çλïℓè ℓ !!!]",
  CN: "[!!! Çλïñá ℓ !!!]",
  CX: "[!!! Çλřïƨƭ₥áƨ Ìƨℓáñδ ℓôřè !!!]",
  CC: "[!!! Çôçôƨ (Kèèℓïñϱ) Ìƨℓáñδƨ ℓôřè₥  !!!]",
  CO: "[!!! Çôℓô₥βïá ℓ !!!]",
  KM: "[!!! Çô₥ôřôƨ ℓ !!!]",
  CG: "[!!! Çôñϱô ℓ !!!]",
  CD: "[!!! Çôñϱô, Ðè₥ôçřáƭïç Rèƥúβℓïç ôƒ ƭλè ℓôřè₥ ïƥƨ !!!]",
  CK: "[!!! Çôôƙ Ìƨℓáñδƨ ℓôř !!!]",
  CR: "[!!! Çôƨƭá Rïçá ℓô !!!]",
  CI: "[!!! Çôƭè δ'ÌƲôïřè ℓôř !!!]",
  HR: "[!!! Çřôáƭïá ℓ !!!]",
  CU: "[!!! Çúβá  !!!]",
  CW: "[!!! Çúřáçáô ℓ !!!]",
  CY: "[!!! Ç¥ƥřúƨ ℓ !!!]",
  CZ: "[!!! Çƺèçλïá ℓ !!!]",
  DK: "[!!! Ðèñ₥ářƙ ℓ !!!]",
  DJ: "[!!! ÐJïβôúƭï ℓ !!!]",
  DM: "[!!! Ðô₥ïñïçá ℓ !!!]",
  DO: "[!!! Ðô₥ïñïçáñ Rèƥúβℓïç ℓôřè !!!]",
  EC: "[!!! Éçúáδôř ℓ !!!]",
  EG: "[!!! Éϱ¥ƥƭ ℓ !!!]",
  SV: "[!!! Éℓ §áℓƲáδôř ℓô !!!]",
  GQ: "[!!! É9úáƭôřïáℓ Gúïñèá ℓôřè !!!]",
  ER: "[!!! Éřïƭřèá ℓ !!!]",
  EE: "[!!! Éƨƭôñïá ℓ !!!]",
  SZ: "[!!! Éƨωáƭïñï ℓ !!!]",
  ET: "[!!! Éƭλïôƥïá ℓ !!!]",
  FK: "[!!! Fáℓƙℓáñδ Ìƨℓáñδƨ (MáℓƲïñáƨ) ℓôřè₥ ï !!!]",
  FO: "[!!! Fářôè Ìƨℓáñδƨ ℓôř !!!]",
  FJ: "[!!! FïJï  !!!]",
  FI: "[!!! Fïñℓáñδ ℓ !!!]",
  FR: "[!!! Fřáñçè ℓ !!!]",
  GF: "[!!! Fřèñçλ Gúïáñá ℓôř !!!]",
  PF: "[!!! Fřèñçλ Þôℓ¥ñèƨïá ℓôřè !!!]",
  TF: "[!!! Fřèñçλ §ôúƭλèřñ Tèřřïƭôřïèƨ ℓôřè₥ ï !!!]",
  GA: "[!!! Gáβôñ ℓ !!!]",
  GM: "[!!! Gá₥βïá ℓ !!!]",
  GE: "[!!! Gèôřϱïá ℓ !!!]",
  DE: "[!!! Gèř₥áñ¥ ℓ !!!]",
  GH: "[!!! Gλáñá ℓ !!!]",
  GI: "[!!! Gïβřáℓƭář ℓô !!!]",
  GR: "[!!! Gřèèçè ℓ !!!]",
  GL: "[!!! Gřèèñℓáñδ ℓô !!!]",
  GD: "[!!! Gřèñáδá ℓ !!!]",
  GP: "[!!! Gúáδèℓôúƥè ℓô !!!]",
  GU: "[!!! Gúá₥  !!!]",
  GT: "[!!! Gúáƭè₥áℓá ℓô !!!]",
  GG: "[!!! Gúèřñƨè¥ ℓ !!!]",
  GN: "[!!! Gúïñèá ℓ !!!]",
  GW: "[!!! Gúïñèá-ßïƨƨáú ℓôř !!!]",
  GY: "[!!! Gú¥áñá ℓ !!!]",
  HT: "[!!! Háïƭï ℓ !!!]",
  HM: "[!!! Hèářδ Ìƨℓáñδ áñδ MçÐôñáℓδ Ìƨℓáñδƨ ℓôřè₥ ïƥƨ !!!]",
  VA: "[!!! Hôℓ¥ §èè ℓ !!!]",
  HN: "[!!! Hôñδúřáƨ ℓ !!!]",
  HK: "[!!! Hôñϱ Kôñϱ ℓô !!!]",
  HU: "[!!! Húñϱář¥ ℓ !!!]",
  IS: "[!!! Ìçèℓáñδ ℓ !!!]",
  IN: "[!!! Ìñδïá ℓ !!!]",
  ID: "[!!! Ìñδôñèƨïá ℓô !!!]",
  IR: "[!!! Ìřáñ (Ìƨℓá₥ïç Rèƥúβℓïç ôƒ) ℓôřè₥ ï !!!]",
  IQ: "[!!! Ìřá9  !!!]",
  IE: "[!!! Ìřèℓáñδ ℓ !!!]",
  IM: "[!!! Ìƨℓè ôƒ Máñ ℓô !!!]",
  IL: "[!!! Ìƨřáèℓ ℓ !!!]",
  IT: "[!!! Ìƭáℓ¥ ℓ !!!]",
  JM: "[!!! Já₥áïçá ℓ !!!]",
  JP: "[!!! Jáƥáñ ℓ !!!]",
  JE: "[!!! Jèřƨè¥ ℓ !!!]",
  JO: "[!!! Jôřδáñ ℓ !!!]",
  KZ: "[!!! Káƺáƙλƨƭáñ ℓô !!!]",
  KE: "[!!! Kèñ¥á ℓ !!!]",
  KI: "[!!! Kïřïβáƭï ℓ !!!]",
  KP: "[!!! Kôřèá (Ðè₥ôçřáƭïç Þèôƥℓè'ƨ Rèƥúβℓïç ôƒ) ℓôřè₥ ïƥƨú₥ !!!]",
  KR: "[!!! Kôřèá, Rèƥúβℓïç ôƒ ℓôřè !!!]",
  KW: "[!!! Kúωáïƭ ℓ !!!]",
  KG: "[!!! K¥řϱ¥ƺƨƭáñ ℓô !!!]",
  LA: "[!!! £áô Þèôƥℓè'ƨ Ðè₥ôçřáƭïç Rèƥúβℓïç ℓôřè₥ ïƥƨ !!!]",
  LV: "[!!! £áƭƲïá ℓ !!!]",
  LB: "[!!! £èβáñôñ ℓ !!!]",
  LS: "[!!! £èƨôƭλô ℓ !!!]",
  LR: "[!!! £ïβèřïá ℓ !!!]",
  LY: "[!!! £ïβ¥á ℓ !!!]",
  LI: "[!!! £ïèçλƭèñƨƭèïñ ℓôř !!!]",
  LT: "[!!! £ïƭλúáñïá ℓô !!!]",
  LU: "[!!! £úжè₥βôúřϱ ℓô !!!]",
  MO: "[!!! Máçáô ℓ !!!]",
  MG: "[!!! Máδáϱáƨçář ℓô !!!]",
  MW: "[!!! Máℓáωï ℓ !!!]",
  MY: "[!!! Máℓá¥ƨïá ℓ !!!]",
  MV: "[!!! MáℓδïƲèƨ ℓ !!!]",
  ML: "[!!! Máℓï  !!!]",
  MT: "[!!! Máℓƭá ℓ !!!]",
  MH: "[!!! Mářƨλáℓℓ Ìƨℓáñδƨ ℓôřè !!!]",
  MQ: "[!!! Mářƭïñï9úè ℓô !!!]",
  MR: "[!!! Máúřïƭáñïá ℓô !!!]",
  MU: "[!!! Máúřïƭïúƨ ℓô !!!]",
  YT: "[!!! Má¥ôƭƭè ℓ !!!]",
  MX: "[!!! Mèжïçô ℓ !!!]",
  FM: "[!!! Mïçřôñèƨïá (Fèδèřáƭèδ §ƭáƭèƨ ôƒ) ℓôřè₥ ïƥƨ !!!]",
  MD: "[!!! MôℓδôƲá, Rèƥúβℓïç ôƒ ℓôřè₥ !!!]",
  MC: "[!!! Môñáçô ℓ !!!]",
  MN: "[!!! Môñϱôℓïá ℓ !!!]",
  ME: "[!!! Môñƭèñèϱřô ℓô !!!]",
  MS: "[!!! Môñƭƨèřřáƭ ℓô !!!]",
  MA: "[!!! Môřôççô ℓ !!!]",
  MZ: "[!!! Môƺá₥βï9úè ℓô !!!]",
  MM: "[!!! M¥áñ₥ář ℓ !!!]",
  NA: "[!!! Ná₥ïβïá ℓ !!!]",
  NR: "[!!! Náúřú ℓ !!!]",
  NP: "[!!! Nèƥáℓ ℓ !!!]",
  NL: "[!!! Nèƭλèřℓáñδƨ ℓô !!!]",
  NC: "[!!! Nèω Çáℓèδôñïá ℓôř !!!]",
  NZ: "[!!! Nèω Zèáℓáñδ ℓô !!!]",
  NI: "[!!! Nïçářáϱúá ℓô !!!]",
  NE: "[!!! Nïϱèř ℓ !!!]",
  NG: "[!!! Nïϱèřïá ℓ !!!]",
  NU: "[!!! Nïúè  !!!]",
  NF: "[!!! Nôřƒôℓƙ Ìƨℓáñδ ℓôř !!!]",
  MK: "[!!! Nôřƭλ Máçèδôñïá ℓôřè !!!]",
  MP: "[!!! Nôřƭλèřñ Mářïáñá Ìƨℓáñδƨ ℓôřè₥  !!!]",
  NO: "[!!! Nôřωá¥ ℓ !!!]",
  OM: "[!!! Ó₥áñ  !!!]",
  PK: "[!!! Þáƙïƨƭáñ ℓ !!!]",
  PW: "[!!! Þáℓáú ℓ !!!]",
  PS: "[!!! Þáℓèƨƭïñè, §ƭáƭè ôƒ ℓôřè₥ !!!]",
  PA: "[!!! Þáñá₥á ℓ !!!]",
  PG: "[!!! Þáƥúá Nèω Gúïñèá ℓôřè !!!]",
  PY: "[!!! Þářáϱúá¥ ℓ !!!]",
  PE: "[!!! Þèřú  !!!]",
  PH: "[!!! Þλïℓïƥƥïñèƨ ℓô !!!]",
  PN: "[!!! Þïƭçáïřñ ℓ !!!]",
  PL: "[!!! Þôℓáñδ ℓ !!!]",
  PT: "[!!! Þôřƭúϱáℓ ℓ !!!]",
  PR: "[!!! Þúèřƭô Rïçô ℓô !!!]",
  QA: "[!!! Qáƭář ℓ !!!]",
  RE: "[!!! Réúñïôñ ℓ !!!]",
  RO: "[!!! Rô₥áñïá ℓ !!!]",
  RU: "[!!! Rúƨƨïáñ Fèδèřáƭïôñ ℓôřè !!!]",
  RW: "[!!! Rωáñδá ℓ !!!]",
  BL: "[!!! §áïñƭ ßářƭλéℓè₥¥ ℓôřè !!!]",
  SH: "[!!! §áïñƭ Hèℓèñá, Âƨçèñƨïôñ áñδ Třïƨƭáñ δá Çúñλá ℓôřè₥ ïƥƨú₥  !!!]",
  KN: "[!!! §áïñƭ Kïƭƭƨ áñδ NèƲïƨ ℓôřè₥ !!!]",
  LC: "[!!! §áïñƭ £úçïá ℓô !!!]",
  MF: "[!!! §áïñƭ Mářƭïñ (Fřèñçλ ƥářƭ) ℓôřè₥ ï !!!]",
  PM: "[!!! §áïñƭ Þïèřřè áñδ Mï9úèℓôñ ℓôřè₥ ï !!!]",
  VC: "[!!! §áïñƭ Vïñçèñƭ áñδ ƭλè Gřèñáδïñèƨ ℓôřè₥ ïƥƨ !!!]",
  WS: "[!!! §á₥ôá ℓ !!!]",
  SM: "[!!! §áñ Mářïñô ℓô !!!]",
  ST: "[!!! §áô Tô₥è áñδ Þřïñçïƥè ℓôřè₥ !!!]",
  SA: "[!!! §áúδï Âřáβïá ℓôř !!!]",
  SN: "[!!! §èñèϱáℓ ℓ !!!]",
  RS: "[!!! §èřβïá ℓ !!!]",
  SC: "[!!! §è¥çλèℓℓèƨ ℓô !!!]",
  SL: "[!!! §ïèřřá £èôñè ℓôř !!!]",
  SG: "[!!! §ïñϱáƥôřè ℓô !!!]",
  SX: "[!!! §ïñƭ Máářƭèñ (Ðúƭçλ ƥářƭ) ℓôřè₥ ï !!!]",
  SK: "[!!! §ℓôƲáƙïá ℓ !!!]",
  SI: "[!!! §ℓôƲèñïá ℓ !!!]",
  SB: "[!!! §ôℓô₥ôñ Ìƨℓáñδƨ ℓôřè !!!]",
  SO: "[!!! §ô₥áℓïá ℓ !!!]",
  ZA: "[!!! §ôúƭλ Âƒřïçá ℓôř !!!]",
  GS: "[!!! §ôúƭλ Gèôřϱïá áñδ ƭλè §ôúƭλ §áñδωïçλ Ìƨℓáñδƨ ℓôřè₥ ïƥƨú₥  !!!]",
  SS: "[!!! §ôúƭλ §úδáñ ℓô !!!]",
  ES: "[!!! §ƥáïñ ℓ !!!]",
  LK: "[!!! §řï £áñƙá ℓô !!!]",
  SD: "[!!! §úδáñ ℓ !!!]",
  SR: "[!!! §úřïñá₥è ℓ !!!]",
  SJ: "[!!! §Ʋáℓβářδ áñδ Jáñ Má¥èñ ℓôřè₥  !!!]",
  SE: "[!!! §ωèδèñ ℓ !!!]",
  CH: "[!!! §ωïƭƺèřℓáñδ ℓô !!!]",
  SY: "[!!! §¥řïáñ Âřáβ Rèƥúβℓïç ℓôřè₥ !!!]",
  TW: "[!!! Táïωáñ, ÞřôƲïñçè ôƒ Çλïñá ℓôřè₥ ï !!!]",
  TJ: "[!!! TáJïƙïƨƭáñ ℓô !!!]",
  TZ: "[!!! Táñƺáñïá, Ûñïƭèδ Rèƥúβℓïç ôƒ ℓôřè₥ ï !!!]",
  TH: "[!!! Tλáïℓáñδ ℓ !!!]",
  TL: "[!!! Tï₥ôř-£èƨƭè ℓô !!!]",
  TG: "[!!! Tôϱô  !!!]",
  TK: "[!!! Tôƙèℓáú ℓ !!!]",
  TO: "[!!! Tôñϱá ℓ !!!]",
  TT: "[!!! Třïñïδáδ áñδ Tôβáϱô ℓôřè₥ !!!]",
  TN: "[!!! Túñïƨïá ℓ !!!]",
  TR: "[!!! Tüřƙï¥è ℓ !!!]",
  TM: "[!!! Túřƙ₥èñïƨƭáñ ℓôř !!!]",
  TC: "[!!! Túřƙƨ áñδ Çáïçôƨ Ìƨℓáñδƨ ℓôřè₥  !!!]",
  TV: "[!!! TúƲáℓú ℓ !!!]",
  UG: "[!!! Ûϱáñδá ℓ !!!]",
  UA: "[!!! Ûƙřáïñè ℓ !!!]",
  AE: "[!!! Ûñïƭèδ Âřáβ É₥ïřáƭèƨ ℓôřè₥ !!!]",
  GB: "[!!! Ûñïƭèδ Kïñϱδô₥ ôƒ Gřèáƭ ßřïƭáïñ áñδ Nôřƭλèřñ Ìřèℓáñδ ℓôřè₥ ïƥƨú₥ δôℓ !!!]",
  US: "[!!! Ûñïƭèδ §ƭáƭèƨ ôƒ Â₥èřïçá ℓôřè₥  !!!]",
  UM: "[!!! Ûñïƭèδ §ƭáƭèƨ Mïñôř Óúƭℓ¥ïñϱ Ìƨℓáñδƨ ℓôřè₥ ïƥƨú !!!]",
  UY: "[!!! Ûřúϱúá¥ ℓ !!!]",
  UZ: "[!!! Ûƺβèƙïƨƭáñ ℓô !!!]",
  VU: "[!!! Váñúáƭú ℓ !!!]",
  VE: "[!!! Vèñèƺúèℓá (ßôℓïƲářïáñ Rèƥúβℓïç ôƒ) ℓôřè₥ ïƥƨ !!!]",
  VN: "[!!! Vïèƭ Ná₥ ℓ !!!]",
  VG: "[!!! Vïřϱïñ Ìƨℓáñδƨ (ßřïƭïƨλ) ℓôřè₥  !!!]",
  VI: "[!!! Vïřϱïñ Ìƨℓáñδƨ (Û.§.) ℓôřè₥ !!!]",
  WF: "[!!! Wáℓℓïƨ áñδ Fúƭúñá ℓôřè !!!]",
  EH: "[!!! Wèƨƭèřñ §áλářá ℓôř !!!]",
  YE: "[!!! Ýè₥èñ ℓ !!!]",
  ZM: "[!!! Zá₥βïá ℓ !!!]",
  ZW: "[!!! Zï₥βáβωè ℓ !!!]",
};
